import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import NavBar from 'components/Navbar';
import Createtabs from 'components/Createtabs';
import styles from './DashBoardHeader.scss';// to import local scss fle

const tabs = ['Student', 'Coach', 'College'];

class DashBoardHeader extends Component {
  static propTypes = {
    tabListener: PropTypes.func.isRequired,
    tab: PropTypes.number.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      headerOnDashboard: true,
    };
  }

  render() {
    return (
      <div className={cn('row', styles.container)}>
        <NavBar {...this.props} />
        <div className={cn('col s12', styles.currentUrl)}>
              Admin Panel
        </div>
        <Createtabs index={this.props.tab} tabs={tabs} tabListener={this.props.tabListener} />
      </div>
    );
  }
}

export default DashBoardHeader;



// WEBPACK FOOTER //
// ./src/components/HeaderWithTabs/DashBoardHeader.js